import PropTypes from 'prop-types';
import {useState, createRef} from 'react';
import css from './medication-reconciliation.scss';
import AddMedicationModal from './Modals/AddMedicationModal';
import {useSelector} from 'react-redux';
import Panel from '@livongo/ui/Panel';
import cn from 'classnames';
import useTransLoader from 'i18n/use-trans-loader';
import {useRouteMatch} from 'react-router-dom';

const MedicationReconciliation = ({
    getMedication,
    reviewedToday,
    newMedicationReview,
    medOptData,
}) => {
    const {path} = useRouteMatch();
    const {t} = useTransLoader(path);
    const medicationReview = useSelector(state => state.medicationReview);
    const [show, setShow] = useState(false);
    const panel = createRef();

    return (
        <>
            <AddMedicationModal
                show={show}
                setShow={setShow}
                getMedication={getMedication}
                reviewId={medicationReview.reviewId}
            />
            <div className={css['medication-reconciliation']}>
                <div className={`row ${css['section-title']}`}>
                    <div
                        className={cn(
                            'col-xs-6',
                            css['section-title'],
                            'collapsed',
                            css['review-title']
                        )}
                    >
                        {t('reconciliation.medReview')}
                    </div>
                </div>
                <Panel
                    ref={panel}
                    className="Panel-container"
                    contentClassName="Panel-content"
                    isOpen
                />
            </div>
        </>
    );
};

MedicationReconciliation.propTypes = {
    getMedication: PropTypes.func,
    reviewedToday: PropTypes.func,
    newMedicationReview: PropTypes.func,
    medOptData: PropTypes.array,
};

export default MedicationReconciliation;
